export default [
  { nome: 'Painel', icone: 'app:painel', url: 'painel-inicio', class: 'btn-menu-painel' },
  { nome: 'Perfil', icone: 'app:perfil', url: 'perfil', class: 'btn-menu-perfil' },
  { nome: 'Avaliação de usados', icone: 'app:avaliacao', url: 'vender', class: 'btn-menu-vender' },
  { nome: 'Política de Privacidade', icone: 'app:politica', url: 'termos-de-uso', params: { url: 'politica-de-privacidade' }, class: 'btn-menu-termos-de-uso' },
  { nome: 'Sair', icone: 'app:sair', url: 'sair', class: 'btn-menu-sair' }
]
